import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const PREVIOUS = '← Previous'
const NEXT = 'Next →'

class Pagination extends React.Component {
  // static PropTypes = {
  //   baseUrl: PropTypes.string.isRequired,
  //   pageCount: PropTypes.number.isRequired,
  //   currentPage: PropTypes.number.isRequired,
  
  // }

    getLink (page, text) {
        let url = '/' + this.props.baseUrl;
        if (page !== 0) url = url + '/' + page;

        return <Link to={url}>{text}</Link>
    }

    render () {
        const { pageCount, currentPage } = this.props;

        const prevItem = (currentPage > 0)
      ? this.getLink(currentPage - 1, PREVIOUS)
      : <span>{PREVIOUS}</span>;

        const nextItem = (currentPage < pageCount)
      ? this.getLink(currentPage + 1, NEXT)
      : <span>{NEXT}</span>;

        return (
          <ul className="pagination">
            <li className="prev">{prevItem}</li>
            <li className="next">{nextItem}</li>
          </ul>
        )
    }
}

Pagination.propTypes = {
    baseUrl: PropTypes.string.isRequired,
    pageCount: PropTypes.number.isRequired,
    currentPage: PropTypes.number.isRequired
};

export default Pagination;